<template>
    <div class="userComment spackage padding-20 bgc box-shadow">
        <div class="actionBank">
            <el-date-picker v-model="params.date" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input class="input" v-model="params.customername" placeholder="评论人"></el-input>
            <el-input class="input" v-model="params.assetname" placeholder="内容名称"></el-input>
            <el-button @click="findAllComment(1)">搜索</el-button>
        </div>
        <el-table ref="commentTable" :data="tableInfo" style="width: 100%;">
            <el-table-column fixed label="评论人" align="left" width="220">
                <template slot-scope="scope">
                    <div class="username">
                        <img :src="scope.row.headimageurl" alt="">
                        {{scope.row.customername}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="内容类型" align="center" prop="kmctypename" width="100"></el-table-column>
            <el-table-column label="内容名称" align="center" min-width="250" class-name="contentnameBox">
                <template slot-scope="scope">
                    <div class="contentname">
                        {{scope.row.assetname}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="评论内容" align="center" min-width="250" class-name="commentcontentBox">
                <template slot-scope="scope">
                    <div class="commentcontent" @click="replyComment(scope.row)">
                        {{scope.row.content}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="评论时间" align="center" prop="datetime" width="220"></el-table-column>
            <el-table-column label="操作" align="right" width="150">
                <template slot-scope="scope">
                    <div class="action">
                        <span @click="replyComment(scope.row)">回复</span>
                        <span class="line" v-if="scope.row.status !== 100">|</span>
                        <span v-if="scope.row.status !== 100" @click="deleteCommentInfo(scope.row)">删除</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="totalPage"  @current-change="fPage"></el-pagination>
        <CommentDesp ref="commentDesp" />
    </div>
</template>
<script>
import CommentDesp from '../components/commentDesp'
import {findAllComment, deleteCommentInfo} from 'api/activeApi.js'
import { mapActions} from 'vuex' // 引入 vuex 组件
export default {
    name: 'UserComment',
    data() {
        return {
            params: {
                date: '',
                customername: '',
                assetname: '',
                begintime: '',
                endtime: ''
            },
            tableInfo: [],
            totalPage: 0,
            clickPage: 1
        }
    },
    created() {
        this.findAllComment(1)
    },
    methods: {
        findAllComment(page) {
            this.setLoading(true)
            let options = {
                page: page,
                pageSize: 10,
                begintime: this.params.begintime,
                endtime: this.params.endtime,
                assetname: this.params.assetname,
                customername: this.params.customername
            }
            findAllComment({
                data: options,
                success: res => {
                    this.setLoading(false)
                    this.tableInfo = res.data.content
                    this.totalPage = res.data.pageinfo.rowCount
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 删除评论
        deleteCommentInfo(row) {
            this.$confirm('确定删除该评论吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                let options = {
                    innerid: row.innerid
                }
                deleteCommentInfo({
                    data: options,
                    success: res => {
                        this.$message.success('删除成功')
                        this.setLoading(false)
                        this.findAllComment(this.clickPage)
                    },
                    error: res => {
                        this.$message.error(res.msg)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {

            })
            
        },
        fPage(){    // 分页
            let clickPage = $(".el-pagination .active").html()
            this.clickPage = clickPage
            this.findAllComment(clickPage)
        },
        replyComment(row) {
            this.$refs.commentDesp.open(row)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        CommentDesp
    },
    watch: {
        'params.date': {
            handler(newV, oldV) {
                if (newV && newV.length) {
                    this.params.begintime = newV[0]
                    this.params.endtime = newV[1]
                } else {
                    this.params.begintime = ''
                    this.params.endtime = ''
                }
            },
            deep: true
        }
    }
}
</script>
<style lang="scss">
    .userComment {
        // min-width: 1000px;
        // box-sizing: border-box;
        .actionBank {
            display: flex;
            align-items: center;
            margin-bottom: 30px;
            .el-date-editor {
                .el-input__icon, .el-range-separator {
                    line-height: 25px;
                }
            }
            .el-input__icon {
                line-height: 32px;
            }
            .input {
                width: 246px;
                margin-left: 30px;
            }
            .el-button {
                margin-left: 30px;
            }
        }
        .el-table {
            .username {
                display: flex;
                align-items: center;
                font-size: 14px;
                img {
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    border-radius: 50%;
                }
            }
            .commentcontentBox, .contentnameBox {
                .cell {
                    min-width: 240px;
                }
            }
            .contentname, .commentcontent {
                width: 224px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                text-align: center;
                margin: auto;
            }
            .commentcontent {
                color: #409EFF;
                cursor: pointer;
            }
            .action {
                span {
                    color: #409EFF;
                    font-size: 14px;
                    cursor: pointer;
                }
                .line {
                    margin: 0 5px;
                }
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }
    }
</style>